import * as React from 'react';

const NotFoundScreen = ({language, t}) => {
    return (
        <div className='d-flex align-items-center justify-content-center'>
            <h1>
                {t('page_not_found')}
            </h1>
        </div>

    );
};

export default NotFoundScreen;